import {ABACPolicyEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Box, Modal, ModalProps} from "@mantine/core";
import {MouseEvent, useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {useABACPolicyAction} from "../../menu/ABACPolicyActionMenu/useABACPolicyAction";
import {EntityActionGroup} from "../../group/EntityActionGroup/EntityActionGroup";
import {BaseABACPolicyDataTable, BaseABACPolicyDataTableProps} from "./BaseABACPolicyDataTable";

export type ABACPolicyDataTableProps = Omit<BaseABACPolicyDataTableProps, 'renderActions'>

export const ABACPolicyDataTable = (props: ABACPolicyDataTableProps) => {
  const {
    ...rest
  } = props

  const navigate = useNavigate()

  const {
    onABACPolicyActionClick
  } = useABACPolicyAction()

  const onViewActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: ABACPolicyEntity) => {
    e.stopPropagation()
    navigate(`/abac-policies/profile?id=${record.id}`)
  }, [navigate])

  const onEditActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: ABACPolicyEntity) => {
    e.stopPropagation()
    onABACPolicyActionClick(record, 'EDIT')
  }, [onABACPolicyActionClick])

  const onDeleteActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: ABACPolicyEntity) => {
    e.stopPropagation()
    onABACPolicyActionClick(record, 'DELETE')
  }, [onABACPolicyActionClick])

  const renderActions = useCallback((record: ABACPolicyEntity, index: number) => {
    return (
      <EntityActionGroup
        permissionPrefix={"abacpolicy"}
        onViewActionClick={(e) => onViewActionClick(e, record)}
        onEditActionClick={(e) => onEditActionClick(e, record)}
        onDeleteActionClick={(e) => onDeleteActionClick(e, record)}
      />
    )
  }, [onEditActionClick, onViewActionClick, onDeleteActionClick])

  return (
    <BaseABACPolicyDataTable
      {...rest}
      renderActions={renderActions}
    />
  )
}

export type ABACPolicyDataTableModalProps = Omit<ModalProps, "onSubmit"> & {
  dataTable: Omit<ABACPolicyDataTableProps, 'recordsPerPageOptions'>
}

export const ABACPolicyDataTableModal = (props: ABACPolicyDataTableModalProps) => {
  const {t} = useTranslation(["common"]);

  const {
    title = t<string>("common.entity.abacpolicy.plural", "ABAC Policies"),
    dataTable,
    ...rest
  } = props;

  return (
    <Modal {...rest} title={title}>
      <Box>
        <ABACPolicyDataTable
          {...dataTable}
          recordsPerPageOptions={[5]}/>
      </Box>
    </Modal>
  );
};
